module.exports = __webpack_public_path__ + "static/img/our-customers-infrastructure-hero.8622ebf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/our-customers-infrastructure-hero.jpg
// module id = j+a3
// module chunks = 0